import Marionette from "backbone.marionette";
import qs from "query-string";
import _ from "lodash";
import $ from "jquery";

const PaginationComponent = Marionette.View.extend({
    template: false,
    ui: {
        page: ".page",
    },
    events: {
        "click @ui.page": "onPageClick",
    },
    onPageClick(e) {
        e.preventDefault();
        const $el = $(e.target);
        const query = qs.parse(window.location.search);
        _.extend(query, { page: $el.attr("data-page") });
        window.location = `${window.location.pathname}?${qs.stringify(query)}`;
    },
});

export default PaginationComponent;
